import DialpadIcon from "@mui/icons-material/Dialpad";
import { MenuItem, Stack, Typography } from "@mui/material";
import { memo } from "react";
import { useTranslation } from "react-i18next";
import { IChangePin } from "./models";

export const ChangePin = memo(({ openModalHandler }: IChangePin) => {
  const { t } = useTranslation();

  return (
    <MenuItem onClick={openModalHandler}>
      <Stack direction={"row"} spacing={1}>
        <DialpadIcon color="action" />
        <Typography>{t("change_pin")}</Typography>
      </Stack>
    </MenuItem>
  );
});
